module.exports = __webpack_public_path__ + "img/symbol_5.419f30f5.png";